/*
 * @Description: 特价活动详情（单店）
 * @Author: et_wl
 * @Date: 2020-02-19 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-09-Mo 10:10:05
*/

import Vue from 'vue'
import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { Swipe, SwipeItem, Popup } from 'vant'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import { getLoginInfo } from '@/utils/loginInfo'
import InfiniteLoading from 'vue-infinite-loading'

import ajax from '../../http/ajax'

import {
    wxShare,
} from '@/utils/wxsdk'

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Popup)

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.specialActivity,
    components: {
        QualityImg,
        InfiniteLoading
    },
    data () {
        return {
            phone: '', // 拨打电话的手机号
            topic_id: '', // 专题id
            sstore_id: '', // 门店id
            latitude: '', // 纬度
            longitude: '', // 经度
            isShowMore: false, // 是否显示更多
            isShowGoTop: false, // 是否显示点击回到顶部的按钮
            isShowExplain: false, // 是否显示活动说明
            isNoList: false, // 是否没有商品数据
            serchFixed: false, // 是否固定搜索
            page: 1,
            pagesize: 100,
            handle_floor_list: [],
        }
    },
    computed: {
        ...mapState({
            list: ({ specialActivity }) => specialActivity.data_list, // 活动商品的数据
            floor_list: ({ specialActivity }) => specialActivity.floor_list, // 楼层的数据
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
    },
    watch: {
        '$route' (to, from) {
            // 对路由变化作出响应...
            if (to.path === from.path || from.path === '/pageNotFound') {
                /* 滚动到页面顶部 */
                /* 滚动到页面顶部 */
                document.body.scrollIntoView()
                this.page = 1
                this.handle_floor_list = []
                this.getData()
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
                // this.infinite()
            }
        }
    },
    created () {
        /* 滚动到页面顶部 */
        document.body.scrollIntoView()
        this.getData()
    },
    methods: {
        ...mapActions([
            'getSpecialActivity',
            'getFloorList',
            'addVisitLog'
        ]),
        async getData () {
            const { topic_id, sstore_id, latitude, longitude } = this.$route.query
            this.topic_id = topic_id
            this.sstore_id = sstore_id
            this.latitude = latitude
            this.longitude = longitude
            // 获取路径传过来的参数
            // latitude 纬度， longitude 经度
            // 请求页面数据
            this.showLoading()
            this.getSpecialActivity({ topic_id: this.topic_id, sstore_id: this.sstore_id, latitude: this.latitude, longitude: this.longitude, sms_id: this.$route.query.sms_id })
                .then(() => {
                    this.uploadLog()
                    this.hideLoading()
                    // 设置头部信息
                    this.$emit('setHeader', {
                        title: this.list.activity_name || '',
                        showHeader: true,
                        showLeft: true,
                        scrollTop: ''
                    })
                    // 如果活动已经结束，当前页面显示404页面的逻辑
                    if (Number(this.list.activity_status) !== 1) {
                        this.$router.push({
                            path: '/pageNotFound',
                            query: {
                                sstore_id: this.sstore_id,
                            }
                        })
                        return
                    }
                    // 如果是活动继续请求，否则就直接跳转
                    // const page_background = this.list.page_color.page_background
                    // this.leftLine.background = `linear-gradient(to left, #ffd295 50%,${page_background} 100%)`
                    // this.rightLine.background = `linear-gradient(to right, #ffd295 50%,${page_background} 100%)`

                    // 配置微信的数据
                    this.configWxShare(this.list.share)
                    this.phone = `tel://${this.list.store_tel}`
                    // 当解释说明的高度大于90的时候出现更多字样
                    this.$nextTick(() => {
                        if (!this.$refs.info) return
                        const info = this.$refs.info
                        const infoParent = this.$refs.infoParent

                        let height = null
                        let maxHeight = null
                        if (window.getComputedStyle) {
                            // 非IE浏览器获取方法
                            height = window.getComputedStyle(info).height
                            maxHeight = window.getComputedStyle(infoParent).height
                        } else {
                            // IE浏览器获取方法
                            height = info.currentStyle['height']
                            maxHeight = infoParent.currentStyle['height']
                        }
                        if (height) {
                            String(height).split('px')[0] * 1 <= String(maxHeight).split('px')[0] * 1 ? this.isShowMore = false : this.isShowMore = true
                        }
                    })
                }).catch(() => {
                    this.hideLoading()
                })
            // 监听页面滚动是否出现点击去顶部的按钮
            window.addEventListener('scroll', this.scrollToTop)
        },
        infinite: _.throttle(function () {
            let params = {
                topic_id: this.topic_id,
                sstore_id: this.sstore_id,
                page: this.page,
                pagesize: this.pagesize
            }
            this.getFloorList(params).then(() => {
                if (this.floor_list.floor_infos && this.floor_list.floor_infos.length && this.floor_list.floor_infos.length === this.pagesize) {
                    this.page++
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                } else {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                }
                this.handle_floor_list = this.handle_floor_list.concat(this.floor_list.floor_infos)
                this.isNoList = _.isEmpty(this.list.main_brand_advs) && _.isEmpty(this.list.harsh_shop) && _.isEmpty(this.handle_floor_list)
            }).catch(() => {
            })
        }, 500),
        // 处理当距离大于1000的时候显示公里，小于的时候显示米
        distanceDispose (value) {
            const num = Number(value)
            const isGreater = num >= 1000
            let distanceText = ''
            let distance = null
            if (isGreater) {
                distance = num / 1000
                distanceText = `距离您<span style="color: #e60014">${Number(distance).toFixed(1)}</span>公里`
            } else {
                distanceText = `距离您<span style="color: #e60014">${num}</span>米`
            }
            return distanceText
        },
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    ...detail
                })
            }
        },
        // 点击导航去门店
        goMap () {
            window.location.href = `https://api.map.baidu.com/marker?location=${this.list.sstore_latitude},${this.list.sstore_longitude}&title=${this.list.store_name}&content=${this.list.store_address}&output=html&src=webapp.baidu.openAPIdemo`
        },
        // 判断当前时间是否超过活动时间
        thinkTime () {
            // 活动结束的时间戳
            const activity_timestamp = Number(this.list.activity_timestamp)
            // // 获取当前时间戳 -》秒
            const timestamp = (new Date()).getTime() / 1000
            return timestamp < activity_timestamp
        },
        // 查看更多解释说明
        explainMore () {
            this.isShowExplain = true
        },
        uploadLog () {
            const {
                user_id = ''
            } = getLoginInfo()
            const {
                sstore_id = '',
                visitType = '',
            } = this.$route.query
            this.addVisitLog({
                sstore_id: sstore_id, // 门店id
                user_id: user_id ? Number(user_id) : 0, // 用户id (0 为未登录)
                channel: 2, // 访问渠道 (1 微养车 2 H5)
                visit_type: visitType === 2 ? 2  : 1, // 访问类型 (1普通进入 2分享链接 3扫二维码(预留))
                page_code: 'specialActivity',
                param_type: 'activity_id',
                param_value: this.list.activity_id,
            })
        },

        // 去商品详情页面
        goShopDetail (goods_id, spu_id, sstore_id, activity_id, goods_type) {
            const query = {
                goods_id,
                spu_id,
                sstore_id,
                goods_type,
                sms_id: this.$route.query.sms_id,
                page_code: 'specialActivity',
            }
            // 判断时间是否为活动过期的时间
            if (this.thinkTime()) query.activity_id = activity_id
            this.$router.push({
                name: 'goodsDetail',
                query
            })
        },

        // 去更多楼层事件
        goMoreFloor (floor_id, sstore_id, activity_id) {
            // 如果活动过期直接刷新页面
            if (!this.thinkTime()) {
                location.reload()
                return
            }
            this.$router.push({
                name: 'goodsList',
                query: {
                    floor_id,
                    sstore_id: sstore_id || this.sstore_id,
                    activity_id: activity_id || this.list.activity_id
                }
            })
        },

        // 跳转外部链接之前先做判断
        activityForecast (type, source, spu_id) {
            // type为0的时候不跳转
            if (type == 0) return // eslint-disable-line
            if (type == 3) { // eslint-disable-line
                window.location.href = source
            } else { // eslint-disable-line
                this.showLoading()
                ajax.post('getShopJudge', { type, source, sstore_id: this.sstore_id }).then(res => {
                    this.hideLoading()
                    // 1 活动详情页面 2 商品详情页面
                    if (type == 1) { // eslint-disable-line
                        this.$router.push({
                            name: 'marketingDetail',
                            query: {
                                topic_id: source
                            }
                        })
                    } else if (type == 2) {  // eslint-disable-line
                        this.$router.push({
                            name: 'goodsDetail',
                            query: {
                                spu_id,
                                goods_type: 'agent',
                                sstore_id: this.sstore_id,
                                goods_id: source
                            }
                        })
                    }
                }).catch(() => {
                    this.hideLoading()
                })
            }
        },

        // 点击之后页面滚到最上面
        toTop () {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },

        // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
                that.isShowGoTop = true
            } else {
                that.isShowGoTop = false
            }
            if (that.scrollTop > 300) {
                that.serchFixed = true
            } else {
                that.serchFixed = false
            }
        }
    },

    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
}
